module.exports = __webpack_public_path__ + "static/CopyMessageBirtAPI-5182000ad381cd7b901c0c7acf4ee875.png";